import {
  FETCH_TASK_TYPE,
  FETCH_TASK_TYPE_SUCCESS,
  FETCH_TASK_TYPE_FAILURE,
  FETCH_TASK_TYPE_MODE,
  FETCH_TASK_TYPE_MODE_SUCCESS,
  FETCH_TASK_TYPE_MODE_FAILURE, 
  FETCH_TASK_TYPE_MODE_CLEAR, 
  SAVE_TASK_TYPE,
  SAVE_TASK_TYPE_SUCCESS,
  SAVE_TASK_TYPE_FAILURE,
  CHANGE_TASK_TYPE_STATUS,
  CHANGE_TASK_TYPE_STATUS_SUCCESS,
  CHANGE_TASK_TYPE_STATUS_FAILURE
} from "./actionTypes";

// Fetch Module
export const fetchTaskType = (unitId) => ({
  type: FETCH_TASK_TYPE,
  payload: { unitId }
});

export const fetchTaskTypeSuccess = (roles) => ({
  type: FETCH_TASK_TYPE_SUCCESS,
  payload: roles,
});

export const fetchTaskTypeFailure = (error) => ({
  type: FETCH_TASK_TYPE_FAILURE,
  payload: error,
});

export const fetchTaskTypeMode = (payload) => ({
  type: FETCH_TASK_TYPE_MODE,
  payload: payload
});

export const fetchTaskTypeModeSuccess = (roles) => ({
  type: FETCH_TASK_TYPE_MODE_SUCCESS,
  payload: roles,
});

export const fetchTaskTypeModeFailure = (error) => ({
  type: FETCH_TASK_TYPE_MODE_FAILURE,
  payload: error,
});

export const fetchTaskTypeModeClear = () => ({
  type: FETCH_TASK_TYPE_MODE_CLEAR,
  payload: '',
});

// Create Project
export const saveTaskType = (formData, isEdit) => ({
  type: SAVE_TASK_TYPE,
  payload: { formData, isEdit },
});

export const saveTaskTypeSuccess = (response) => ({
  type: SAVE_TASK_TYPE_SUCCESS,
  payload: response,
});

export const saveTaskTypeFailure = (error) => ({
  type: SAVE_TASK_TYPE_FAILURE,
  payload: error,
});

export const changeTaskTypeStatus = (payload) => ({
  type: CHANGE_TASK_TYPE_STATUS,
  payload,
});

export const changeTaskTypeStatusSuccess = (response) => ({
  type: CHANGE_TASK_TYPE_STATUS_SUCCESS,
  payload: response,
});

export const changeTaskTypeStatusFailure = (error) => ({
  type: CHANGE_TASK_TYPE_STATUS_FAILURE,
  payload: error,
});

